export function gaspScrolltrigger() {

    // プラグインの登録
    gsap.registerPlugin(ScrollTrigger);


    //
    gsap.utils.toArray(".js-trigger").forEach((target) => {
        gsap.to(target, {
            scrollTrigger: {
                toggleActions: "play none none reverse",
                trigger: target,
                start: "top 80%",
                //markers: true,
                toggleClass: {
                    targets: target,
                    className: "show",
                },
            },
        });
    });

    //
    gsap.utils.toArray(".js-trigger-delay").forEach((target) => {
        gsap.to(target, {
            scrollTrigger: {
                toggleActions: "play none none reverse",
                trigger: target,
                start: "top 85%",
                //markers: true,
                toggleClass: {
                    targets: target,
                    className: "show",
                },
            },
        });
    });

    gsap.utils.toArray(".js-trigger-fadeInUp").forEach((target) => {
        gsap.from(target, {
            y: 20,
            autoAlpha: 0,
            scrollTrigger: {
                toggleActions: "play none none reverse",
                trigger: target,
                start: "top 85%",
                //markers: true,
                toggleClass: {
                    targets: target,
                    className: "show",
                },
            },
        });
    });

    gsap.utils.toArray(".js-trigger-fadeInScale").forEach((target) => {
        gsap.from(target, {
            scale: .5,
            autoAlpha: 0,
            scrollTrigger: {
                toggleActions: "play none none reverse",
                trigger: target,
                start: "top 85%",
                //markers: true,
                toggleClass: {
                    targets: target,
                    className: "show",
                },
            },
        });
    });

}
